import React, { useState, useEffect, useContext } from 'react';
import {
  Button,
  TextField,
  MenuItem,
  IconButton,
  Box,
  Typography,
  Modal,
  Checkbox,
  CircularProgress,
  useTheme,
} from '@mui/material';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import {
  faFolderOpen,
  faLock,
  faTrash,
  faSearch,
  faFolder,
  faFilePdf,
  faFileWord,
  faFileImage,
  faFileVideo,
  faFileCode,
  faFile,
  faTimes,
  faUnlock,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  getFolder,

} from '../../apis/agent';
import {
  getCompanyDevices,
  editLastLogin,
  requestOperation,
  checkValid,
} from '../../apis/axios';
import ConfirmDialog from '../common/ConfirmationModal';
import AuthContext from '../../AuthContext';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const FileExplorerCard = ({
  uuid,
  sys_uuid,
  data,
  setPathCurrent,
  onFileChange,
  device_id,
  disabled,
  licence_id,
  deletion,
  enc_dec
}) => {
  const auth = useContext(AuthContext);
  const theme = useTheme();
  const [fileData, setFileData] = useState(null);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [filePath, setFilePath] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [currentPath, setCurrentPath] = useState([]);
  const [sortBy, setSortBy] = useState('Name (A-Z)');
  const [openFolders, setOpenFolders] = useState({});
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingItems, setLoadingItems] = useState({});
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState('encrypt');
  const [password, setPassword] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [canDecrypt, setCanDecrypt] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [pathBeforeOperation, setPathBeforeOperation] = useState([]);
  const [openRequest, setOpenRequest] = useState(false);
  const[reqMsg,setReqMsg]=useState("")
  const deviceId = device_id;
  // Map API response to file data
  const checkOpertaion=async(data)=>{
    const res=await checkValid({licence_id:licence_id,operation:data})
    if (res.data.status === "expired") {
    setSnackbarOpen(true)
        setSnackbarMsg("This license has expired.");
        return;
      }

      if (res.data.status === "not_allowed") {
         setSnackbarOpen(true)
       setSnackbarMsg("Operation is not permitted for this license.");
        return;
      }

      if (res.data.status !== "allowed") {
         setSnackbarOpen(true)
       setSnackbarMsg("Invalid license response.");
        return;
      }
  }
  const mapApiResponseToFileData = (response) => {
    const folderName = response.path.split('\\').pop() || 'Root';
    const folders = response.folders.map((folder) => ({
      name: folder,
      isFolder: true,
      children: [],
      path: response.path ? `${response.path}\\${folder}` : folder,
    }));
    const files = response.files.map((file) => ({
      name: file.name,
      isFolder: false,
      type: inferFileType(file.name),
      size: formatFileSize(file.size_bytes),
      modified: formatDate(file.last_modified),
      status: file.name.toLowerCase().endsWith('.enc') ? 'Encrypted' : 'Normal',
      path: response.path ? `${response.path}\\${file.name}` : file.name,
    }));
    return {
      name: folderName,
      isFolder: true,
      children: [...folders, ...files],
      path: response.path || '',
    };
  };


  // Initialize file data
  useEffect(() => {
    if (data) {
      const mappedData = mapApiResponseToFileData(data);
      setFileData(mappedData);
      setCurrentPath([mappedData]);
      setOpenFolders({ [mappedData.name]: true });
    }
  }, [data]);

  // Filter and sort files
  const currentFolder = currentPath[currentPath.length - 1] || {};
  const currentFiles = currentFolder.children || [];

  const filteredFiles = currentFiles
    .filter((item) => item.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      if (a.isFolder && !b.isFolder) return -1;
      if (!a.isFolder && b.isFolder) return 1;
      switch (sortBy) {
        case 'Name (A-Z)':
          return a.name.localeCompare(b.name);
        case 'Name (Z-A)':
          return b.name.localeCompare(a.name);
        case 'Size (Largest First)':
          if (a.isFolder && b.isFolder) return a.name.localeCompare(b.name);
          return parseSizeToBytes(b.size) - parseSizeToBytes(a.size);
        case 'Size (Smallest First)':
          if (a.isFolder && b.isFolder) return a.name.localeCompare(b.name);
          return parseSizeToBytes(a.size) - parseSizeToBytes(b.size);
        case 'Modified (Newest First)':
          if (a.isFolder && b.isFolder) return a.name.localeCompare(b.name);
          return parseDate(b.modified).getTime() - parseDate(a.modified).getTime();
        case 'Modified (Oldest First)':
          if (a.isFolder && b.isFolder) return a.name.localeCompare(b.name);
          return parseDate(a.modified).getTime() - parseDate(b.modified).getTime();
        default:
          return a.name.localeCompare(b.name);
      }
    });

  // Update decryption eligibility
  useEffect(() => {
    const selectedItems = (currentFolder.children || []).filter((item) =>
      selectedFiles.includes(item.name)
    );
    const canDecryptFiles =
      selectedItems.length > 0 &&
      selectedItems.every((item) => !item.isFolder && item.status === 'Encrypted');
    setCanDecrypt(canDecryptFiles);
  }, [selectedFiles, currentFolder]);

  // Update select-all checkbox
  useEffect(() => {
    const allSelected =
      filteredFiles.length > 0 &&
      filteredFiles.every((item) => selectedFiles.includes(item.name));
    setIsAllSelected(allSelected);
  }, [filteredFiles, selectedFiles]);

  // Handle modal open/close
  const openModalHandler = (mode) => {
    setModalMode(mode);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setPassword('');
  };

  // Utility functions
  const formatFileSize = (bytes) => {
    if (bytes === 'Unknown' || bytes == null) return 'Unknown';
    const kb = bytes / 1024;
    const mb = kb / 1024;
    const gb = mb / 1024;
    const formatNumber = (num) => {
      const integerPart = Math.floor(num);
      const integerDigits = integerPart.toString().length;
      let formatted;
      if (integerDigits >= 3) {
        formatted = num.toFixed(1);
      } else if (integerDigits === 2) {
        formatted = num.toFixed(2);
      } else {
        formatted = num.toFixed(3);
      }
      return Number(formatted).toString();
    };
    if (gb >= 1) {
      return `${formatNumber(gb)} GB`;
    } else if (mb >= 1) {
      const mbIntegerPart = Math.floor(mb);
      if (mbIntegerPart.toString().length >= 4) {
        return `${formatNumber(gb)} GB`;
      }
      return `${formatNumber(mb)} MB`;
    } else {
      const kbIntegerPart = Math.floor(kb);
      if (kbIntegerPart.toString().length >= 4) {
        return `${formatNumber(mb)} MB`;
      }
      return `${formatNumber(kb)} KB`;
    }
  };

  const parseSizeToBytes = (size) => {
    if (size === '--') return 0;
    const [value, unit] = size.split(' ');
    const num = parseFloat(value);
    if (unit === 'GB') return num * 1024 * 1024 * 1024;
    if (unit === 'MB') return num * 1024 * 1024;
    if (unit === 'KB') return num * 1024;
    return 0;
  };

  const formatDate = (dateString) => {
    if (dateString === 'Unknown' || !dateString) return 'Unknown';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Unknown';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, '0');
    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${period}`;
  };

  const parseDate = (dateString) => {
    if (dateString === '--' || dateString === 'Unknown') return new Date(0);
    const [datePart, timePart, period] = dateString.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    let [hours, minutes] = timePart.split(':').map(Number);
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    const fullYear = 2000 + year;
    const date = new Date(fullYear, month - 1, day, hours, minutes);
    return date;
  };

  const inferFileType = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'gitignore':
      case 'sqlite3':
        return 'System File';
      case 'zip':
      case 'txt':
        return 'Document';
      case 'py':
      case 'ps1':
        return 'Executable';
      case 'pdf':
        return 'PDF';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'Image';
      case 'mp4':
      case 'avi':
      case 'mkv':
        return 'Video';
      case 'xml':
        return 'XML';
      case 'enc':
        return 'Encrypted File';
      default:
        return 'File';
    }
  };

  const fetchSubFolder = async (folderNode) => {
    try {
      const newPath = folderNode.path;
      setPathCurrent(newPath.replace(/[\\/]/g, '\\\\'));
      setLoading(true);
      const response = await getFolder(uuid, newPath, sys_uuid);
      const mappedData = mapApiResponseToFileData(response.data);
      return mappedData.children;
    } catch (err) {
      setError(`Failed to load contents of folder ${folderNode.name}.`);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (name) => {
    setSelectedFiles((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
    );
  };

  const encryptFilesInFolder = (folder) => {
    if (!folder.children) return;
    folder.children.forEach((item) => {
      if (item.isFolder) {
        encryptFilesInFolder(item);
      } else {
        item.status = 'Encrypted';
      }
    });
  };

  const restorePathAfterRefresh = async (pathToRestore) => {
    if (!pathToRestore || pathToRestore.length === 0) return;

    try {
      setLoading(true);
      let currentNode = fileData;
      const newPath = [currentNode];
      const newOpenFolders = { ...openFolders, [currentNode.name]: true };

      for (let i = 1; i < pathToRestore.length; i++) {
        const folderName = pathToRestore[i].name;
        const folderNode = currentNode.children.find(
          (child) => child.isFolder && child.name === folderName
        );

        if (!folderNode) {
          setError(`Failed to restore path: Folder ${folderName} not found.`);
          break;
        }

        folderNode.children = await fetchSubFolder(folderNode);
        newPath.push(folderNode);
        newOpenFolders[folderName] = true;
        currentNode = folderNode;
      }

      setCurrentPath(newPath);
      setOpenFolders(newOpenFolders);
    } catch (err) {
      setError('Failed to restore the previous path after refresh.');
    } finally {
      setLoading(false);
    }
  };

  const handleEncrypt = () => {
    if (selectedFiles.length === 0) {
      setError('No files selected for encryption.');
      return;
    }
    else{
      checkOpertaion("encryption")
      openModalHandler('encrypt');
    }
    
  };

  const handleDecrypt = () => {
    if (selectedFiles.length === 0) {
      setError('No files selected for decryption.');
      return;
    }
 else{
   checkOpertaion("decryption")
    openModalHandler('decrypt');
 }
  };

  const checkDeviceStatus = async () => {
    try {
      const companyId = auth.admin || '';
      if (!companyId) throw new Error('companyId is empty or undefined.');
      if (!uuid) throw new Error('uuid is empty or undefined.');

      const deviceResponse = await getCompanyDevices({ company_id: companyId });

      if (deviceResponse && Array.isArray(deviceResponse.data)) {
        const device = deviceResponse.data.find((dev) => dev.uuid === uuid);
        if (!device) throw new Error('Device not found.');
        if (!device.id) throw new Error('Device found but id is missing.');

        const payload = { id: deviceId, uuid: uuid };
        const statusResponse = await editLastLogin(payload);
        const isActive = statusResponse.data.isActive === 1;

        return { isActive, deviceId: device.id };
      } else {
        throw new Error('Invalid response from getCompanyDevices.');
      }
    } catch (err) {
      setError(
        'Failed to verify device status. Please ensure the device is registered and try again.'
      );
      return { isActive: false, deviceId: null };
    }
  };

  const handleConfirmEncrypt = async () => {
    if (!password) {
      setError('Encryption password is required.');
      return;
    }
    if (selectedFiles.length === 0) {
      setError('No files selected for encryption.');
      return;
    }

    setPathBeforeOperation([...currentPath]);
    closeModal();

    try {
      setLoadingItems((prev) => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach((name) => {
          newLoadingItems[name] = true;
        });
        return newLoadingItems;
      });
      setError(null);

      const { isActive, deviceId } = await checkDeviceStatus();

      const pathsToEncrypt = selectedFiles.map((name) => {
        const item = currentFolder.children.find((item) => item.name === name);
        return item.path.replace(/[\\/]/g, '\\\\');
      });

      if (isActive) {
        const operationPromises = pathsToEncrypt.map(async (path) => {
          const operationData = {
            device_id: deviceId,
            user_id: auth.user,
            type: 'encryption',
            json: { path: path, password: password },
          };
          const operationResponse = await requestOperation(operationData);
          setOpenRequest(true);
          const operationLogId = operationResponse.data.log_id;

          if (!operationLogId) {
            throw new Error('No log_id returned from addOperation');
          }

        });

        await Promise.all(operationPromises);

        const updatedData = { ...fileData };
        const files = currentFolder.children;
        files.forEach((item) => {
          if (selectedFiles.includes(item.name)) {
            if (item.isFolder) {
              encryptFilesInFolder(item);
            } else {
              item.status = 'Encrypted';
              if (!item.name.toLowerCase().endsWith('.enc')) {
                item.name = `${item.name}.enc`;
                item.path = `${item.path}.enc`;
                item.type = inferFileType(item.name);
              }
            }
          }
        });
        setFileData(updatedData);
        setCurrentPath((prev) => [...prev.map((folder) => ({ ...folder }))]);
        setSelectedFiles([]);
        if (onFileChange) {
          await onFileChange();
          await restorePathAfterRefresh(pathBeforeOperation);
        }
        setError(null);
      } else {
        const userId = auth.user;
        if (!userId) throw new Error('User ID not found. Please log in again.');

        const queuePromises = pathsToEncrypt.map(async (path) => {
          const operationData = {
            device_id: device_id,
            user_id: userId,
            type: 'encryption',
            json: { path: path, password: password },
          };
          const queueResponse = await requestOperation(operationData);
          setOpenRequest(true);
          const queueLogId = queueResponse.data.log_id;

          if (!queueLogId) {
            throw new Error('No log_id returned from addQueueOperation');
          }
        });

        await Promise.all(queuePromises);

        setError('Device is offline. Encryption operation has been queued.');
        setSelectedFiles([]);
      }
    } catch (err) {
      setError(err.message || 'Failed to process encryption. Please try again.');
    } finally {
      setLoadingItems((prev) => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach((name) => {
          newLoadingItems[name] = false;
        });
        return newLoadingItems;
      });
      setPathBeforeOperation([]);
    }
  };

  const handleConfirmDecrypt = async () => {
    if (!password) {
      setError('Decryption password is required.');
      return;
    }
    if (selectedFiles.length === 0) {
      setError('No files selected for decryption.');
      return;
    }

    setPathBeforeOperation([...currentPath]);
    closeModal();

    try {
      setLoadingItems((prev) => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach((name) => {
          newLoadingItems[name] = true;
        });
        return newLoadingItems;
      });
      setError(null);

      const { isActive, deviceId } = await checkDeviceStatus();

      const pathsToDecrypt = selectedFiles.map((name) => {
        const item = currentFolder.children.find((item) => item.name === name);
        return item.path.replace(/[\\/]/g, '\\\\');
      });

      if (isActive) {
        const operationPromises = pathsToDecrypt.map(async (path) => {
          const operationData = {
            device_id: deviceId,
            user_id: auth.user,
            type: 'decryption',
            json: { path: path, password: password },
          };
          const operationResponse = await requestOperation(operationData);
          setOpenRequest(true);
          const operationLogId = operationResponse.data.log_id;

          if (!operationLogId) {
            throw new Error('No log_id returned from addOperation');
          }

        });

        await Promise.all(operationPromises);

        const updatedData = { ...fileData };
        const files = currentFolder.children;
        files.forEach((item) => {
          if (selectedFiles.includes(item.name)) {
            item.status = 'Normal';
            if (item.name.toLowerCase().endsWith('.enc')) {
              item.name = item.name.substring(0, item.name.length - 4);
              item.path = item.path.substring(0, item.path.length - 4);
              item.type = inferFileType(item.name);
            }
          }
        });
        setFileData(updatedData);
        setCurrentPath((prev) => [...prev.map((folder) => ({ ...folder }))]);
        setSelectedFiles([]);
        if (onFileChange) {
          await onFileChange();
          await restorePathAfterRefresh(pathBeforeOperation);
        }
        setError(null);
      } else {
        const userId = auth.user;
        if (!userId) throw new Error('User ID not found. Please log in again.');

        const queuePromises = pathsToDecrypt.map(async (path) => {
          const operationData = {
            device_id: device_id,
            user_id: userId,
            type: 'decryption',
            json: { path: path, password: password },
          };
          const queueResponse = await requestOperation(operationData);
          const queueLogId = queueResponse.data.log_id;
          openRequest(true);

          if (!queueLogId) {
            throw new Error('No log_id returned from addQueueOperation');
          }
        });

        await Promise.all(queuePromises);

        setError('Device is offline. Decryption operation has been queued.');
        setSelectedFiles([]);
      }
    } catch (err) {
      setError(err.message || 'Failed to process decryption. Please try again.');
    } finally {
      setLoadingItems((prev) => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach((name) => {
          newLoadingItems[name] = false;
        });
        return newLoadingItems;
      });
      setPathBeforeOperation([]);
    }
  };

  const handleDelete = () => {
    if (selectedFiles.length === 0) {
      setError('No files selected for deletion.');
      return;
    }
    checkOpertaion('delete_file/folder');
    setOpenDeleteConfirm(true);
  };
  const handleConfirmDelete = async () => {
    const updatedData = { ...fileData };
    const pathsToDelete = selectedFiles.map((name) => {
      const item = currentFolder.children.find((item) => item.name === name);
      return item.path;
    });

    setPathBeforeOperation([...currentPath]);
    setOpenDeleteConfirm(false);

    try {
      setLoadingItems((prev) => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach((name) => {
          newLoadingItems[name] = true;
        });
        return newLoadingItems;
      });
      setError(null);

      const { isActive, deviceId } = await checkDeviceStatus();

      if (isActive) {
        const operationPromises = pathsToDelete.map(async (path) => {
          const formattedPath = path.replace(/[\\/]/g, '\\\\');
          const operationData = {
            device_id: deviceId,
            user_id: auth.user,
            type: 'delete_file/folder',
            json: { path: formattedPath },
          };
          const operationResponse = await requestOperation(operationData);
          setOpenRequest(true);
          if (operationResponse.data.success === false) {
            setError(
              operationResponse.data.error || 'Failed to delete selected items.'
            );
            throw new Error(
              operationResponse.data.error || 'Failed to delete selected items.'
            );
          }
          const operationLogId = operationResponse.data.log_id;

          if (!operationLogId) {
            throw new Error('No log_id returned from addOperation');
          }
        });

        await Promise.all(operationPromises);

        currentFolder.children = currentFolder.children.filter(
          (item) => !selectedFiles.includes(item.name)
        );
        setFileData(updatedData);
        setCurrentPath((prev) => [...prev.map((folder) => ({ ...folder }))]);
        setSelectedFiles([]);
        if (onFileChange) {
          await onFileChange();
          await restorePathAfterRefresh(pathBeforeOperation);
        }
        setError(null);
      } else {
        const userId = auth.user;
        if (!userId) throw new Error('User ID not found. Please log in again.');
        if (!device_id) throw new Error('Device ID not found. Cannot queue operation.');

        const queuePromises = pathsToDelete.map(async (path) => {
          const formattedPath = path.replace(/[\\/]/g, '\\\\');
          const operationData = {
            device_id: device_id,
            user_id: userId,
            type: 'delete_file/folder',
            json: { path: formattedPath },
          };
          const queueResponse = await requestOperation(operationData);

          setOpenRequest(true);
          const queueLogId = queueResponse.data.log_id;

          if (!queueLogId) {
            throw new Error('No log_id returned from addQueueOperation');
          }
        });

        await Promise.all(queuePromises);

        setError('Device is offline. Deletion operation has been queued.');
        setSelectedFiles([]);
      }
    } catch (err) {
      setError('Failed to delete selected items.');
    } finally {
      setLoadingItems((prev) => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach((name) => {
          newLoadingItems[name] = false;
        });
        return newLoadingItems;
      });
      setPathBeforeOperation([]);
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirm(false);
  };

  const toggleFolder = async (folderNode) => {
    const folderName = folderNode.name;
    setOpenFolders((prev) => {
      const isOpen = !prev[folderName];
      return { ...prev, [folderName]: isOpen };
    });
    if (!openFolders[folderName]) {
      try {
        const subFolderContents = await fetchSubFolder(folderNode);
        folderNode.children = subFolderContents;
        setCurrentPath((prev) => {
          const index = prev.findIndex((f) => f.name === folderName);
          if (index === -1 || index === prev.length - 1) {
            return [...prev, folderNode];
          }
          return prev.slice(0, index + 1).concat([folderNode]);
        });
        setError(null);
      } catch (err) {
        // Error handled by fetchSubFolder
      }
    } else {
      setCurrentPath((prev) => {
        const index = prev.findIndex((f) => f.name === folderName);
        if (index !== -1 && index < prev.length - 1) {
          return prev.slice(0, index + 1);
        }
        return prev;
      });
      setError(null);
    }
    setSelectedFiles([]);
  };

  const getIconForItem = (item) => {
    if (item.isFolder) return faFolder;
    switch (item.type) {
      case 'PDF':
        return faFilePdf;
      case 'Document':
        return faFileWord;
      case 'Image':
        return faFileImage;
      case 'Video':
        return faFileVideo;
      case 'Executable':
        return faFileCode;
      case 'Encrypted File':
        return faLock;
      case 'System File':
      case 'XML':
      default:
        return faFile;
    }
  };

  const FileNode = ({ node, level = 0 }) => {
    if (!node.isFolder) return null;
    const hasChildren = node.children?.some((child) => child.isFolder);
    const isOpen = openFolders[node.name] || false;
    const handleClick = () => toggleFolder(node);

    return (
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            py: 1,
            px: `${level * 16}px`,
            color: 'text.primary',
            '&:hover': { bgcolor: 'action.hover', cursor: 'pointer' },
            borderRadius: '8px',
          }}
          onClick={handleClick}
        >
          {hasChildren ? (
            <IconButton size="small">
              {isOpen ? <ExpandMore fontSize="small" /> : <ChevronRight fontSize="small" />}
            </IconButton>
          ) : (
            <Box sx={{ width: 24 }} />
          )}
          <FontAwesomeIcon
            icon={isOpen ? faFolderOpen : faFolder}
            style={{ color: theme.palette.secondary.dark, width: 16, height: 16 }}
          />
          <Typography variant="body2" sx={{ truncate: true, flex: 1 }} onClick={() => {
    setFilePath("https://example.com/sample.pdf");
    setViewerOpen(true);
  }}>
            {node.name}
          </Typography>
        </Box>
        {isOpen && hasChildren && (
          <Box>
            {node.children
              .filter((child) => child.isFolder)
              .map((child, index) => (
                <FileNode key={child.name} node={child} level={level + 1} />
              ))}
          </Box>
        )}
      </Box>
    );
  };

  if (!auth.isLoggedIn || !auth.user) {
    return (
      <Box
        component="section"
        sx={{
          p: { xs: 2, sm: 4, md: 6 },
          bgcolor: 'background.paper',
          borderRadius: '24px',
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[4],
        }}
      >
        <Typography sx={{ textAlign: 'center', color: 'error.main' }}>
          User not logged in. Please log in to access the file explorer.
        </Typography>
      </Box>
    );
  }

  if (error && !fileData) {
    return (
      <Box
        component="section"
        sx={{
          p: { xs: 2, sm: 4, md: 6 },
          bgcolor: 'background.paper',
          borderRadius: '24px',
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[4],
        }}
      >
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
          <FontAwesomeIcon icon={faFolderOpen} style={{ color: theme.palette.primary.main }} />
          File Explorer
        </Typography>
        <Typography sx={{ textAlign: 'center', color: 'error.main' }}>
          {error}
        </Typography>
      </Box>
    );
  }

  if (!fileData) {
    return (
      <Box
        component="section"
        sx={{
          p: { xs: 2, sm: 4, md: 6 },
          bgcolor: 'background.paper',
          borderRadius: '24px',
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[4],
        }}
      >
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
          <FontAwesomeIcon icon={faFolderOpen} style={{ color: theme.palette.primary.main }} />
          File Explorer
        </Typography>
        <Typography sx={{ textAlign: 'center', color: 'text.secondary' }}>
          No folder data available.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="section"
      sx={{
        p: { xs: 2, sm: 4, md: 6 },
        bgcolor: 'background.paper',
        borderRadius: '24px',
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[4],
      }}
    >
      {/* Sticky container for both toolbars */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: theme.palette.background.default,
          pb: 2,
          pt: 2,
        }}
      >
        {/* Title Bar */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FontAwesomeIcon icon={faFolderOpen} style={{ color: theme.palette.primary.main }} />
            File Explorer
          </Typography>
        </Box>

        {/* Action + Search Bar */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
         
           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            {deletion!==0 && (
               <Button
              variant="contained"
              color="error"
              onClick={handleDelete}
              disabled={disabled}
              startIcon={<FontAwesomeIcon icon={faTrash} />}
              sx={{ minWidth: { xs: '100px', sm: '120px' } }}
            >
              Delete
            </Button>
            )}
           {enc_dec!==0 && (
           
            <>
            <Button
              variant="contained"
              onClick={handleEncrypt}
              startIcon={<FontAwesomeIcon icon={faLock} />}
              sx={{ minWidth: { xs: '100px', sm: '120px' } }}
            >
              Encrypt
            </Button>
             <Button
              variant="outlined"
              onClick={handleDecrypt}
              disabled={!canDecrypt}
              startIcon={<FontAwesomeIcon icon={faUnlock} />}
              sx={{ minWidth: { xs: '100px', sm: '120px' } }}
            >
              Decrypt
            </Button>
            </>
           )}
          </Box>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <Box sx={{ position: 'relative', width: { xs: '100%', sm: '200px' } }}>
              <FontAwesomeIcon
                icon={faSearch}
                style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: theme.palette.text.secondary,
                  width: 16,
                  height: 16,
                }}
              />
              <TextField
                placeholder="Search Files"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="small"
                fullWidth
                sx={{
                  '& .MuiInputBase-root': {
                    pl: 5,
                    height: '40px',
                    borderRadius: '50px',
                  },
                }}
              />
            </Box>

            <TextField
              select
              size="small"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              sx={{
                width: { xs: '100%', sm: '150px' },
                '& .MuiInputBase-root': { height: '40px' },
              }}
            >
              <MenuItem value="Name (A-Z)">Name (A-Z)</MenuItem>
              <MenuItem value="Name (Z-A)">Name (Z-A)</MenuItem>
              <MenuItem value="Size (Largest First)">Size (Largest First)</MenuItem>
              <MenuItem value="Size (Smallest First)">Size (Smallest First)</MenuItem>
              <MenuItem value="Modified (Newest First)">Modified (Newest First)</MenuItem>
              <MenuItem value="Modified (Oldest First)">Modified (Oldest First)</MenuItem>
            </TextField>
          </Box>
        </Box>
      </Box>


      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
        <Box
          sx={{
            width: { xs: '100%', md: '240px' },
            overflowX: 'auto',
            borderRight: { md: `1px solid ${theme.palette.divider}` },
            pr: { md: 2 },
            pb: { xs: 2, md: 0 },
          }}
        >
          <Box sx={{ minWidth: '200px' }}>
            <FileNode node={fileData} />
          </Box>
        </Box>

        <Box sx={{ flex: 1, overflow: 'auto' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
              <CircularProgress size={32} />
            </Box>
          ) : (
            <Box sx={{ minWidth: { xs: '300px', sm: '500px' } }}>
              <Box
                sx={{
                  display: 'flex',
                  bgcolor: 'background.default',
                  borderRadius: '16px 16px 0 0',
                  px: 3,
                  py: 2,
                  fontWeight: 'bold',
                  color: 'text.primary',
                }}
              >
                <Box sx={{ width: '40px', mr: 2 }}>
                  <Checkbox
                    checked={isAllSelected}
                    onChange={() => {
                      setIsAllSelected((prev) => {
                        const newState = !prev;
                        setSelectedFiles(newState ? filteredFiles.map((item) => item.name) : []);
                        return newState;
                      });
                    }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>Name</Box>
                <Box sx={{ width: '100px' }}>Type</Box>
                <Box sx={{ width: '100px' }}>Size</Box>
                <Box sx={{ flex: 1 }}>Modified</Box>
                <Box sx={{ width: '80px' }}>Status</Box>
              </Box>

              {filteredFiles.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    px: 3,
                    py: 1.5,
                    '&:hover': { bgcolor: 'action.hover' },
                    color: 'text.primary',
                  }}
                >
                  <Box sx={{ width: '40px', mr: 2 }}>
                    <Checkbox
                      checked={selectedFiles.includes(item.name)}
                      onChange={() => handleSelect(item.name)}
                      disabled={loadingItems[item.name]}
                    />
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      cursor: item.isFolder ? 'pointer' : 'default',
                    }}
                    onClick={() => item.isFolder && toggleFolder(item)}
                  >
                    <FontAwesomeIcon
                      icon={getIconForItem(item)}
                      style={{ color: theme.palette.text.primary, width: 16, height: 16 }}
                    />
                    <Typography variant="body2" sx={{ truncate: true }}>
                      {item.name}
                    </Typography>
                  </Box>
                  <Box sx={{ width: '100px' }}>{item.isFolder ? 'Folder' : item.type}</Box>
                  <Box sx={{ width: '100px' }}>{item.isFolder ? '--' : item.size}</Box>
                  <Box sx={{ flex: 1 }}>{item.isFolder ? '--' : item.modified}</Box>
                  <Box sx={{ width: '80px' }}>
                    {item.isFolder ? (
                      <Typography sx={{ color: 'text.secondary' }}>--</Typography>
                    ) : (
                      <Box
                        component="span"
                        sx={{
                          px: 2,
                          py: 0.5,
                          borderRadius: '50px',
                          fontSize: '0.75rem',
                          fontWeight: 'medium',
                          bgcolor: item.status === 'Encrypted' ? 'success.light' : 'warning.light',
                          color: item.status === 'Encrypted' ? '#000' : '#000',
                          display: 'inline-block',
                          textAlign: 'center',
                        }}
                      >
                        {item.status}
                      </Box>
                    )}
                  </Box>
                  {loadingItems[item.name] && (
                    <Box
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(0, 0, 0, 0.1)',
                      }}
                    >
                      <CircularProgress size={24} />
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>

      {error && (
        <Typography sx={{ textAlign: 'center', color: 'error.main', mt: 3 }}>
          {error}
        </Typography>
      )}

      <Modal
        open={openModal}
        onClose={closeModal}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            p: { xs: 2, sm: 3 },
            borderRadius: '24px',
            width: '90%',
            maxWidth: '500px',
            boxShadow: theme.shadows[6],
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              {modalMode === 'encrypt' ? 'Encryption Settings' : 'Decryption Settings'}
            </Typography>
            <IconButton onClick={closeModal}>
              <FontAwesomeIcon icon={faTimes} style={{ color: theme.palette.primary.main, width: 20, height: 20 }} />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              {modalMode === 'encrypt' ? 'Encryption Password*' : 'Decryption Password*'}
            </Typography>
            <TextField
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={modalMode === 'encrypt' ? 'Enter a strong password' : 'Enter the decryption password'}
              type="password"
              fullWidth
              size="small"
            />
            {password && (
              <Typography
                variant="caption"
                sx={{ color: 'error.main', mt: 1 }}
              >
                ⚠️ {modalMode === 'encrypt'
                  ? 'Please store your encryption password securely. If forgotten, the encrypted data cannot be recovered or decrypted.'
                  : 'Ensure the password matches the one used for encryption.'}
              </Typography>
            )}
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
            <Button variant="outlined" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={modalMode === 'encrypt' ? handleConfirmEncrypt : handleConfirmDecrypt}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>

      <ConfirmDialog
        open={openDeleteConfirm}
        title="Confirm Deletion"
        message={`Are you sure you want to delete ${selectedFiles.length} selected item(s)? This action cannot be undone.`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="Delete"
        cancelText="Cancel"
        confirmButtonColor="error"
      />
      <ConfirmDialog
        open={openRequest}
        title="Request Sent"
        message="Request is sent to Admin, You Will Receive OTP Shortly"
        onConfirm={() => setOpenRequest(false)}
        onCancel={() => setOpenRequest(false)}
        confirmText="OK"
        cancelText="Cancel"
        confirmButtonColor="primary"
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default FileExplorerCard;